import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = {
    id
  }
  return doHttp('/module/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 新增/编辑
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/module/addOrUpdate.action', HTTP_TYPE_POST, params)
}

/**
 * 列表
 * @param name
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiGetList (name, pageIndex = 1, pageSize = 20) {
  let params = {
    name,
    pageIndex,
    pageSize
  }
  return doHttp('/module/list.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = {
    id
  }
  return doHttp('/module/detail.action', HTTP_TYPE_GET, params)
}
